import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
} from '@material-ui/core';
import MBack from '../view/MBack';
import MSnackbar from '../view/MSnackbar';
import AppUtils from '../../control/apputlis';
import ChatGroupItem from './ChatGroupItem';
import { withRouter } from "react-router-dom"
import MNoLiving from '../view/MNoLiving';
import FIMUtils from '../../im/FIMUtils';
import IMEventEmitter, { IMEvent } from '../../net/IMEventEmitter';

class ChatGroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'ChatGroup');
        IMEventEmitter.on(IMEvent.GROUP_INFO_CHANGE, this.onGroupInfoChange, this);
        let groupList = FIMUtils.getGroupList();
        console.log('getGroupList', groupList);
        this.setState({ data: groupList });
    }

    componentWillUnmount() {
        this.setState = () => false;
        IMEventEmitter.on(IMEvent.GROUP_INFO_CHANGE, this.onGroupInfoChange, this);
    }

    onGroupInfoChange = (evt) => {
        let groupList = FIMUtils.getGroupList();
        console.log('getGroupList', groupList);
        this.setState({ data: groupList });
    }

    onClickItem = (data) => {
        let nick = data.titleName;
        let userId = data.groupkey;
        this.props.history.push({ pathname: '/privateletter/' + userId + '/groupProfile', data: nick });
    }

    renderEmpty = () => {
        return (
            <Grid container justifycontent='center' alignItems='center' style={{ marginTop: 64 }}>
                <MNoLiving title='暂无群聊' />
            </Grid>
        );
    }

    render() {
        const { classes } = this.props;
        const { data } = this.state;
        return (
            <MBack title='群聊'>
                <Grid container direction='row' style={{ height: 16 }}></Grid>
                {data.length == 0 && this.renderEmpty()}
                {
                    data.length > 0 && <Grid container direction='column' alignItems='center'>
                        <Grid container direction='column' alignItems='center' className={classes.container}>
                            {
                                data.map((item, i) => (
                                    <ChatGroupItem key={i} data={item} end={i == (data.length - 1)} onClick={() => this.onClickItem(item)} />
                                ))
                            }
                        </Grid>
                        <Grid container direction='column' alignItems='center' justifycontent='center'>
                            <Typography style={{ fontSize: 12, color: '#878787' }}>{data.length + '个群聊'}</Typography>
                        </Grid>
                    </Grid>
                }
                <MSnackbar ref={(ref) => { this.toast = ref }} />
            </MBack >
        );
    }
}
export default withRouter(withStyles((theme) => ({
    container: {
        width: '100vw',
        padding: theme.spacing(0, 0, 0, 0),
    },
    searchView: {
        backgroundColor: '#E7E7E7',
        width: 'calc(100vw - 24px)',
        height: 32,
        borderRadius: 8,
    },
    searchInput: {
        flex: 1,
        width: '100%',
        height: '100%',
        margin: theme.spacing(0, 0, 0, 1),
        backgroundColor: 'transparent',
        justifyContent: 'center',
        border: 'none',
        outline: 'none',
        color: '#3A445F',
        fontSize: theme.typography.pxToRem(11),
    },
    searchButton: {
        width: '100%',
        height: 32,
        backgroundColor: '#2E2E2E',
        borderRadius: 8,
        width: 'calc(100vw - 24px)',
    }
}))(ChatGroup));
